module.exports = __webpack_public_path__ + "img/mais.dff020d1.svg";